import { createContext, useContext, useEffect, useRef, useState } from "react";
import { I18N_CONFIG_KEY } from "../../../i18n/Metronici18n";
import * as authHelper from "../redux/LoginAction";
import { getUserData } from "../redux/LoginCRUD";

const initAuthContextPropsState = {
  auth: authHelper.getAuth(),
  saveAuth: () => {},
  currentUser: undefined,
  setCurrentUser: () => {},
  logout: () => {},
  promoShow: false,
  setPromoShow: () => {},
  urgentShow: false,
  setUrgentShow: () => {},
};

const AuthContext = createContext(initAuthContextPropsState);

const useAuth = () => {
  return useContext(AuthContext);
};

const fontCss = {
  color: "#181a20",
  fontWeight: "bold",
};

const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(authHelper.getAuth());
  const [promoShow, setPromoShow] = useState(false);
  const [urgentShow, setUrgentShow] = useState(false);
  const [currentUser, setCurrentUser] = useState();

  const saveAuth = (auth) => {
    setAuth(auth);
    if (auth) {
      authHelper.setAuth(auth);
    } else {
      authHelper.removeAuth();
    }
  };

  const logout = () => {
    localStorage.removeItem("UserData");
    localStorage.removeItem(I18N_CONFIG_KEY);
    saveAuth(undefined);
    setCurrentUser(undefined);
  };

  return (
    <AuthContext.Provider
      value={{
        auth,
        saveAuth,
        currentUser,
        setCurrentUser,
        logout,
        promoShow,
        setPromoShow,
        urgentShow,
        setUrgentShow,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

const AuthInit = ({ children }) => {
  const { auth, logout, setCurrentUser } = useAuth();
  const didRequest = useRef(false);
  const [showSplashScreen, setShowSplashScreen] = useState(true);

  useEffect(() => {
    const requestUser = async () => {
      try {
        if (!didRequest.current) {
          const data = getUserData();

          if (data) {
            setCurrentUser(data);
          }
        }
      } catch (error) {
        console.error(error);
        if (!didRequest.current) {
          logout();
        }
      } finally {
        setShowSplashScreen(false);
      }

      return () => (didRequest.current = true);
    };

    if (auth) {
      requestUser();
    } else {
      logout();
      setShowSplashScreen(false);
    }
    // eslint-disable-next-line
  }, []);

  return showSplashScreen ? <>Loading</> : <>{children}</>;
};

export { AuthInit, AuthProvider, fontCss, useAuth };
